module.exports = __webpack_public_path__ + "static/media/user.0780cd48.svg";